import { graphql } from '../__generated__/gql';

export const GET_JOINTS_BY_CERTIFICATE_ID = graphql(/* GraphQL */ `
  query jointsByCertificateId($certificateId: Int!) {
    jointsByCertificateId(certificateId: $certificateId) {
      jointId
      certificateId
      jointNumber
      additionalDetails
      tagId
      pIdNo
      flangeSize
      rating
      boltDiameter
      boltQuantity
      boltLength
      boltMaterial
      gasketType
      torqueValue
      hydraulicToolRef
      hydraulicToolPass
      hydraulicToolPumpPressure
      createdBy
      updatedBy
      createdAt
      updatedAt
      supervisedAssembly
    }
  }
`);

export const CREATE_JOINT = graphql(/* GraphQL */ `
  mutation CreateJoint($input: JointInput!) {
    createJoint(input: $input) {
      jointId
    }
  }
`);

export const UPDATE_JOINT = graphql(/* GraphQL */ `
  mutation UpdateJoint($input: JointInput!) {
    updateJoint(input: $input) {
      jointId
    }
  }
`);

export const UPDATE_JOINT_STEP = graphql(/* GraphQL */ `
  mutation UpdateJointStep($stepId: Int!, $comments: String) {
    updateJointStep(stepId: $stepId, comments: $comments) {
      stepId
      jointId
      signedBy
      signedAt
      comments
    }
  }
`);

export const SIGN_JOINT_STEP = graphql(/* GraphQL */ `
  mutation SignJointStep($stepId: Int!, $comments: String) {
    signJointStep(stepId: $stepId, comments: $comments) {
      stepId
      jointId
      signedBy
      signedAt
      comments
    }
  }
`);

export const REMOVE_JOINT = graphql(/* GraphQL */ `
  mutation RemoveJoint($jointId: Int!) {
    removeJoint(jointId: $jointId)
  }
`);

export const GET_JOINT_DETAILS = graphql(/* GraphQL */ `
  query JointDetails($jointId: Int!) {
    jointDetails(jointId: $jointId) {
      jointId
      certificateId
      jointNumber
      additionalDetails
      tagId
      pIdNo
      flangeSize
      rating
      boltDiameter
      boltQuantity
      boltLength
      boltMaterial
      gasketType
      torqueValue
      hydraulicToolRef
      hydraulicToolPass
      hydraulicToolPumpPressure
      createdBy
      updatedBy
      createdAt
      updatedAt
      hasFlangeDefect
      defectMediaUrl
      actualTorque
      supervisedAssembly

      tarCertificate {
        certificateId
        type
      }

      tarJointInstallationSteps {
        stepId
        jointId
        stepNo
        stepTitle
        signedBy
        signedAt
        createdBy
        createdAt
        updatedBy
        updatedAt
        comments
      }
    }
  }
`);

export const GET_JOINT_INSTALLATION_STEP_DETAILS = graphql(/* GraphQL */ `
  query jointInstallationStepDetails($jointId: Int!, $stepNo: Int!) {
    jointInstallationStepDetails(jointId: $jointId, stepNo: $stepNo) {
      stepId
      jointId
      stepNo
      stepTitle
      signedBy
      signedAt
      createdBy
      createdAt
      updatedBy
      updatedAt
      comments
    }
  }
`);

export const GET_JOINTS_BY_PID = graphql(/* GraphQL */ `
  query jointsbyPID($pIdNo: String!) {
    jointsbyPID(pIdNo: $pIdNo) {
      jointId
      certificateId
      jointNumber
      additionalDetails
      tagId
      pIdNo
      flangeSize
      rating
      boltDiameter
      boltQuantity
      boltLength
      boltMaterial
      gasketType
      torqueValue
      hydraulicToolRef
      hydraulicToolPass
      hydraulicToolPumpPressure
      createdBy
      updatedBy
      createdAt
      updatedAt
      supervisedAssembly
    }
  }
`);